import { DateTime } from "luxon";

const formatDate = (iso?: string | null) => {
  if (!iso) return "-";
  const dt = DateTime.fromISO(iso);
  return dt.isValid ? dt.toFormat("MMM d, yyyy") : "-";
};

export const formatStartDate = (iso?: string | null) => formatDate(iso);

export const formatEndDate = (iso?: string | null) =>
  iso ? formatDate(iso) : "Present";

export const formatDateRange = (start?: string | null, end?: string | null) => {
  if (!start && !end) return "Present";
  if (start && !end) return `${formatDate(start)} - Present`;
  if (!start && end) return `Until ${formatDate(end)}`;
  return `${formatDate(start)} - ${formatDate(end)}`;
};
